import React from 'react';
import { Flex, Heading, Text, Card, Link, Box } from '@magicpatterns/cubed';
export function LegalPrivacySection() {
  return <Flex direction="column" gap="4" data-id="element-39">
      <Box data-id="element-40">
        <Heading size="5" mb="2" data-id="element-41">
          Legal & Privacy
        </Heading>
        <Text size="3" color="gray" data-id="element-42">
          Review our policies and legal documentation.
        </Text>
      </Box>
      <Card variant="surface" size="2" data-id="element-43">
        <Flex direction="column" gap="4" data-id="element-44">
          <Link href="https://www.magicpatterns.com/docs/documentation/legal/privacy" underline="hover" target="_blank" rel="noopener noreferrer" data-id="element-45">
            <Text size="3" data-id="element-46">Privacy Policy</Text>
          </Link>
          <Link href="https://www.magicpatterns.com/docs/documentation/legal/terms" underline="hover" target="_blank" rel="noopener noreferrer" data-id="element-47">
            <Text size="3" data-id="element-48">Terms of Service</Text>
          </Link>
        </Flex>
      </Card>
    </Flex>;
}